<template>
  <modal name="modalCancellAllAppointment" class="modal-cancell-all-appointment" :width="'25%'" :height="'auto'" :scrollable="true">
    <div class="modal-header">
      <div class="modal-close-img" @click="hideModal()" @mouseover="isHoverClose = true"
           @mouseleave="isHoverClose = false">
        <img src="../../../static/img/info-modal-close.svg" alt="close" v-if="!isHoverClose">
        <img src="../../../static/img/info-modal-close-hover.svg" alt="close" v-if="isHoverClose">
      </div>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to cancel all appointments?</p>
      <div class="btn-container">
        <b-button class="btn-yes" @click="onYes()">
          <b-spinner variant="primary" v-if="loading"></b-spinner>
          Yes
        </b-button>
        <b-button class="btn-no" @click="onNo()">
          No
        </b-button>
      </div>
    </div>
  </modal>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'ModalCancellAllAppointment',
  components: {
  },
  props: {
    eventId: {
      type: Number,
      default: null
    },
    getEventStaffingById: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    onYes () {
      this.loading = true;
      this.cancelAllAppiontment(this.eventId).then((response) => {
        this.loading = false;
        this.$modal.hide('modalCancellAllAppointment');
        if (response.message) {
          this.$toastr('error', response.message, '');
        } else {
          this.$toastr('success', 'Cancel all appointments successful!', '');
          this.getEventStaffingById();
        }
      }).catch(function (response) {
        this.$toastr('error', response.message, '');
      }).finally(() => {
        this.loadMoreLoading = false;
      });
    },
    onNo () {
      this.$modal.hide('modalCancellAllAppointment');
    },
    ...mapActions({
      cancelAllAppiontment: 'ACTION_CANCEL_ALL_APPOINTMENTS'
    })
  }
}
</script>


// WEBPACK FOOTER //
// ModalCancellAllAppointment.vue?5bed5c8b